module.exports = __webpack_public_path__ + "img/bookshelf05.95c94031.jpg";